"use strict";

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollingBlockTracker = void 0;

var json_rpc_random_id_1 = __importDefault(require("json-rpc-random-id"));

var pify_1 = __importDefault(require("pify"));

var BaseBlockTracker_1 = require("./BaseBlockTracker");

var logging_utils_1 = require("./logging-utils");

var log = (0, logging_utils_1.createModuleLogger)(logging_utils_1.projectLogger, 'polling-block-tracker');
var createRandomId = (0, json_rpc_random_id_1.default)();
var sec = 1000;

var PollingBlockTracker = /*#__PURE__*/function (_BaseBlockTracker_1$B) {
  _inherits(PollingBlockTracker, _BaseBlockTracker_1$B);

  var _super = _createSuper(PollingBlockTracker);

  function PollingBlockTracker() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PollingBlockTracker);

    var _a; // parse + validate args


    if (!opts.provider) {
      throw new Error('PollingBlockTracker - no provider specified.');
    }

    _this = _super.call(this, {
      blockResetDuration: (_a = opts.blockResetDuration) !== null && _a !== void 0 ? _a : opts.pollingInterval
    }); // config

    _this._provider = opts.provider;
    _this._pollingInterval = opts.pollingInterval || 20 * sec;
    _this._retryTimeout = opts.retryTimeout || _this._pollingInterval / 10;
    _this._keepEventLoopActive = opts.keepEventLoopActive === undefined ? true : opts.keepEventLoopActive;
    _this._setSkipCacheFlag = opts.setSkipCacheFlag || false;
    return _this;
  } // trigger block polling


  _createClass(PollingBlockTracker, [{
    key: "checkForLatestBlock",
    value: function () {
      var _checkForLatestBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._updateLatestBlock();

              case 2:
                _context.next = 4;
                return this.getLatestBlock();

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkForLatestBlock() {
        return _checkForLatestBlock.apply(this, arguments);
      }

      return checkForLatestBlock;
    }()
  }, {
    key: "_start",
    value: function () {
      var _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._synchronize();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _start() {
        return _start2.apply(this, arguments);
      }

      return _start;
    }()
  }, {
    key: "_end",
    value: function () {
      var _end2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _end() {
        return _end2.apply(this, arguments);
      }

      return _end;
    }()
  }, {
    key: "_synchronize",
    value: function () {
      var _synchronize2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _a, promise, newErr, _promise;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this._isRunning) {
                  _context4.next = 20;
                  break;
                }

                _context4.prev = 1;
                _context4.next = 4;
                return this._updateLatestBlock();

              case 4:
                promise = timeout(this._pollingInterval, !this._keepEventLoopActive);
                this.emit('_waitingForNextIteration');
                _context4.next = 8;
                return promise;

              case 8:
                _context4.next = 18;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](1);
                newErr = new Error("PollingBlockTracker - encountered an error while attempting to update latest block:\n".concat((_a = _context4.t0.stack) !== null && _a !== void 0 ? _a : _context4.t0));

                try {
                  this.emit('error', newErr);
                } catch (emitErr) {
                  console.error(newErr);
                }

                _promise = timeout(this._retryTimeout, !this._keepEventLoopActive);
                this.emit('_waitingForNextIteration');
                _context4.next = 18;
                return _promise;

              case 18:
                _context4.next = 0;
                break;

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 10]]);
      }));

      function _synchronize() {
        return _synchronize2.apply(this, arguments);
      }

      return _synchronize;
    }()
  }, {
    key: "_updateLatestBlock",
    value: function () {
      var _updateLatestBlock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var latestBlock;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._fetchLatestBlock();

              case 2:
                latestBlock = _context5.sent;

                this._newPotentialLatest(latestBlock);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _updateLatestBlock() {
        return _updateLatestBlock2.apply(this, arguments);
      }

      return _updateLatestBlock;
    }()
  }, {
    key: "_fetchLatestBlock",
    value: function () {
      var _fetchLatestBlock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var req, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                req = {
                  jsonrpc: '2.0',
                  id: createRandomId(),
                  method: 'eth_blockNumber',
                  params: []
                };

                if (this._setSkipCacheFlag) {
                  req.skipCache = true;
                }

                log('Making request', req);
                _context6.next = 5;
                return (0, pify_1.default)(function (cb) {
                  return _this2._provider.sendAsync(req, cb);
                })();

              case 5:
                res = _context6.sent;
                log('Got response', res);

                if (!res.error) {
                  _context6.next = 9;
                  break;
                }

                throw new Error("PollingBlockTracker - encountered error fetching block:\n".concat(res.error.message));

              case 9:
                return _context6.abrupt("return", res.result);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _fetchLatestBlock() {
        return _fetchLatestBlock2.apply(this, arguments);
      }

      return _fetchLatestBlock;
    }()
  }]);

  return PollingBlockTracker;
}(BaseBlockTracker_1.BaseBlockTracker);

exports.PollingBlockTracker = PollingBlockTracker;
/**
 * Waits for the specified amount of time.
 *
 * @param duration - The amount of time in milliseconds.
 * @param unref - Assuming this function is run in a Node context, governs
 * whether Node should wait before the `setTimeout` has completed before ending
 * the process (true for no, false for yes). Defaults to false.
 * @returns A promise that can be used to wait.
 */

function timeout(duration, unref) {
  return new Promise(function (resolve) {
    var timeoutRef = setTimeout(resolve, duration); // don't keep process open

    if (timeoutRef.unref && unref) {
      timeoutRef.unref();
    }
  });
}